import Immutable from 'seamless-immutable'
import { faqConstants } from '../constants'

const initialState = Immutable({
  faqLoading: false,
  faq: [],
  faqRelated: [],
  refinedFaqs: [],
  faqCategories: [],
  tagCloud: [],
  lastCreatedFaqVoteResponse: null,
})

const faqReducer = (state, action) => {
  const currentState = state || initialState
  switch (action.type) {
    case faqConstants.REQUEST:
      return {
        ...currentState,
        faqLoading: true,
      }

    case faqConstants.SUCCESS: {
      const payload = action.response && action.response.payload
      const faqData = payload && payload.faqFormatted ? payload.faqFormatted : payload

      return {
        ...currentState,
        faq: Array.isArray(faqData) ? faqData : [],
        faqLoading: false,
      }
    }

    case faqConstants.SUCCESS_RELATED: {
      const payload = action.response && action.response.payload

      return {
        ...currentState,
        faqRelated: Array.isArray(payload) ? payload : [],
        faqLoading: false,
      }
    }

    case faqConstants.REFINED_SUCCESS: {
      const payload = action.response && action.response.payload
      const faqData = payload && payload.faqFormatted ? payload.faqFormatted : payload

      return {
        ...currentState,
        refinedFaqs: Array.isArray(faqData) ? faqData : [],
        faqLoading: false,
      }
    }

    case faqConstants.SET_ACTIVE: {
      const {
        body: { index },
      } = action

      if (!Array.isArray(currentState.faq) || !currentState.faq[index]) {
        return currentState
      }

      const { isOpen } = currentState.faq[index]

      return {
        ...currentState,
        faq: [
          ...currentState.faq.slice(0, index),
          {
            ...currentState.faq[index],
            isOpen: !isOpen,
          },
          ...currentState.faq.slice(index + 1),
        ],
      }
    }

    case faqConstants.CATEGORY_SUCCESS: {
      const payload = action.response && action.response.payload
      const faqCategories =
        payload && payload.faqCategoryFormatted ? payload.faqCategoryFormatted : payload

      return {
        ...currentState,
        faqCategories: Array.isArray(faqCategories) ? faqCategories : [],
        faqLoading: false,
      }
    }

    case faqConstants.TAG_CLOUD_SUCCESS: {
      const payload = action.response && action.response.payload
      const tagCloud = payload && payload.TagCloudFormatted ? payload.TagCloudFormatted : payload

      return {
        ...currentState,
        tagCloud: Array.isArray(tagCloud) ? tagCloud : [],
        faqLoading: false,
      }
    }

    case faqConstants.SET_FAQ_SCORE_SUCCESS: {
      const {
        response: { lastCreatedFaqVoteResponse },
      } = action

      return {
        ...currentState,
        lastCreatedFaqVoteResponse,
      }
    }

    default:
      return currentState
  }
}

export default faqReducer
